export const colors = {
  primary: '#8C4799',
  secondary: '#223E7C',
}
